import { Link } from "react-router-dom";
import { Home, Search, Phone, ArrowLeft } from "lucide-react";
import { Button } from "./ui/button";
import { Card, CardContent } from "./ui/card";
import { companyInfo } from "../data/mock";

export const NotFoundPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center px-4">
      <Card className="max-w-2xl w-full">
        <CardContent className="p-12 text-center">
          <div className="mb-6">
            <h1 className="text-9xl font-bold text-slate-900 mb-2">404</h1>
            <h2 className="text-3xl font-bold text-slate-900 mb-4">Page Not Found</h2>
            <p className="text-lg text-slate-600 mb-8">
              The page you're looking for doesn't exist or has been moved.
            </p>
          </div>

          <div className="space-y-4 mb-8">
            <Link to="/">
              <Button size="lg" className="w-full sm:w-auto gap-2">
                <Home className="w-5 h-5" />
                Go to Homepage
              </Button>
            </Link>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/services/breakdown-recovery">
                <Button variant="outline" className="w-full sm:w-auto">
                  Breakdown Recovery
                </Button>
              </Link>
              <Link to="/services/vehicle-transport">
                <Button variant="outline" className="w-full sm:w-auto">
                  Vehicle Transport
                </Button>
              </Link>
              <Link to="/blog">
                <Button variant="outline" className="w-full sm:w-auto">
                  Read Our Blog
                </Button>
              </Link>
            </div>
          </div>

          <div className="border-t pt-8">
            <h3 className="text-xl font-bold text-slate-900 mb-4">
              Need Car Recovery in Hackney?
            </h3>
            <p className="text-slate-600 mb-6">
              Available 24/7 for emergency breakdown recovery across East London
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a href={`tel:${companyInfo.phone}`}>
                <Button size="lg" className="bg-red-600 hover:bg-red-700 text-white gap-2">
                  <Phone className="w-5 h-5" />
                  Call: {companyInfo.phone}
                </Button>
              </a>
              <Link to="/#quote">
                <Button size="lg" variant="outline">
                  Get a Quote
                </Button>
              </Link>
            </div>
          </div>

          <div className="mt-8 text-sm text-slate-500">
            <p>
              Lost? Use the navigation above or contact us for immediate assistance.
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
